import JassEnum from './enum';

/**
 * type camerafield
 */
export default class JassCameraField extends JassEnum {}
